var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 102,
    viewBox: "0 0 110 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9988 71.3867C51.9235 71.3867 49.3457 73.9645 49.3457 77.0398C49.3457 80.115 51.9235 82.6928 54.9988 82.6928C57.961 82.6928 60.6518 80.115 60.5161 77.1754C60.6518 73.9419 58.0966 71.3867 54.9988 71.3867Z",
    fill: "#5A53DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.323 91.4202C110.873 85.2923 110.896 77.9886 107.368 71.8833L71.9578 10.559C68.4529 4.38583 62.1215 0.722656 55.0212 0.722656C47.921 0.722656 41.5896 4.40844 38.0847 10.5364L2.62878 71.9285C-0.898727 78.1016 -0.876115 85.4506 2.69661 91.5785C6.22412 97.6386 12.5329 101.279 19.5879 101.279H90.3189C97.3965 101.279 103.751 97.5933 107.323 91.4202ZM99.6351 86.9882C97.6679 90.38 94.1856 92.3925 90.2963 92.3925H19.5653C15.7212 92.3925 12.2616 90.4253 10.3395 87.1013C8.39489 83.7321 8.37228 79.7071 10.3169 76.3153L45.7729 14.9457C47.6949 11.5765 51.1319 9.58664 55.0212 9.58664C58.8879 9.58664 62.3476 11.5991 64.2696 14.9683L99.703 76.3379C101.602 79.6393 101.58 83.619 99.6351 86.9882Z",
    fill: "#5A53DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5966 31.7006C50.9057 32.4694 49.2324 34.9115 49.2324 37.8737C49.3681 39.6601 49.4812 41.4691 49.6168 43.2554C50.0012 50.0617 50.3856 56.7323 50.77 63.5386C50.9057 65.845 52.6921 67.5183 54.9985 67.5183C57.305 67.5183 59.1139 65.732 59.227 63.4029C59.227 62.001 59.227 60.7121 59.3627 59.2875C59.6114 54.9233 59.8828 50.5592 60.1315 46.195C60.2672 43.3685 60.5159 40.542 60.6516 37.7155C60.6516 36.6979 60.5159 35.7934 60.1315 34.8889C58.9783 32.3564 56.2874 31.0675 53.5966 31.7006Z",
    fill: "#5A53DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.8e880382f44ad3ad2bce070790c74cb5.svg";
export { ForwardRef as ReactComponent };